<div class="sumit-payment-page">

    <h2>תודה על הרכישה</h2>
    <p>הרכישה התבצע בהצלחה ומחקה לאישור סופי
        <br>
        חשבונית תשלח במייל
    </p>
    <p>
        <a target="_blank" href={{customerHistoryURL}}>
            לחץ לראות היסטורית תשלומים וחשבוניות
        </a>
    </p>
    <p>
        <a  href="/user">
            לחץ לראות סטטוס הרכישה
        </a>
    </p>

</div>